import React, { useState } from 'react'

import { translate } from '~/core/translate'
import Modal from '~/components/common/modal'
import {
  StyledCloseLargeIcon,
  Container,
  TitleContainer,
  Title,
  DescriptionContainer,
  ButtonsContainer,
  CheckboxContainer,
  StyledCheckbox,
  ConfirmedLabel,
  StyledConfirmButton,
  StyledGoBackButton
} from './styled'

const CancelAccountDialog = ({ onConfirm, onClose }) => {
  const [confirmed, setConfirmed] = useState(false)

  return (
    <Modal
      size='small'
      visible width='375px'
      height='auto'
      onClose={onClose}
    >
      <Container>
        <TitleContainer>
          <Title>{translate('confirm_cancel_subscription')}</Title>
          <StyledCloseLargeIcon onClick={onClose} />
        </TitleContainer>
        <DescriptionContainer dangerouslySetInnerHTML={{ __html: translate('confirm_cancel_account_description') }} />
        <CheckboxContainer>
          <StyledCheckbox
            onChange={() => setConfirmed(!confirmed)}
            isChecked={confirmed}
          />
          <ConfirmedLabel>{translate('confirm_delete_account')}</ConfirmedLabel>
        </CheckboxContainer>
        <ButtonsContainer>
          <StyledConfirmButton
            onClick={onConfirm}
            disabled={!confirmed}
            theme={{
              fontColorSecondaryDisabled: '#F09696'
            }}
          >
            {translate('cancel_subscription')}
          </StyledConfirmButton>
          <StyledGoBackButton
            onClick={onClose}
          >
            {translate('go_back')}
          </StyledGoBackButton>
        </ButtonsContainer>
      </Container>
    </Modal>
  )
}

export default CancelAccountDialog
